import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { getErrorMessage } from '../utils/errorHandler';
import data from '../data/paomakeup';

const LoginPage = () => {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/mis-citas';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const registerOptions = {
    email: {
      required: 'El email es requerido',
      pattern: {
        value: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,4}$/,
        message: 'El email no es valido',
      },
    },
    password: {
      required: 'La contrasena es requerida',
      minLength: { value: 6, message: 'La contrasena debe tener al menos 6 caracteres' },
    },
  };

  const onSubmit = async (formData) => {
    try {
      setIsSubmitting(true);
      setShowAlert(false);
      await login({ email: formData.email, password: formData.password });
      navigate(from, { replace: true });
    } catch (err) {
      setAlertMessage(getErrorMessage(err));
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="my-5">
      <Helmet>
        <title>Iniciar Sesion - {data.title}</title>
      </Helmet>
      <Row className="justify-content-center">
        <Col sm={8} md={6} lg={5}>
          <h1 className="mb-4 text-center">Iniciar Sesion</h1>

          {showAlert && (
            <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}

          {/* Google Sign-In */}
          {/* <div className="d-flex justify-content-center mb-3">
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                setShowAlert(false);
                setIsSubmitting(true);
                loginWithGoogle(credentialResponse.credential)
                  .then(() => navigate(from, { replace: true }))
                  .catch((err) => {
                    setAlertMessage(getErrorMessage(err));
                    setShowAlert(true);
                  })
                  .finally(() => setIsSubmitting(false));
              }}
              onError={() => {
                setAlertMessage('Error al iniciar sesion con Google. Intente de nuevo.');
                setShowAlert(true);
              }}
              text="signin_with"
              width="100%"
            />
          </div> */}

          {/* <div className="d-flex align-items-center mb-3">
            <hr className="flex-grow-1" />
            <span className="px-3 text-muted small">o continue con su correo</span>
            <hr className="flex-grow-1" />
          </div> */}

          <Form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="loginEmail">
              <Form.Label>Correo electronico</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese su correo"
                {...register('email', registerOptions.email)}
              />
              <small className="text-danger">
                {errors?.email && errors.email.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3" controlId="loginPassword">
              <Form.Label>Contrasena</Form.Label>
              <Form.Control
                type="password"
                placeholder="Ingrese su contrasena"
                {...register('password', registerOptions.password)}
              />
              <small className="text-danger">
                {errors?.password && errors.password.message}
              </small>
            </Form.Group>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <Link to="/recuperar-contrasena" className="text-decoration-none">
                ¿Olvido su contrasena?
              </Link>
            </div>

            <div className="d-grid mb-3">
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <span className="d-inline-flex align-items-center gap-2">
                    <Spinner animation="border" size="sm" /> Iniciando sesion...
                  </span>
                ) : 'Iniciar Sesion'}
              </Button>
            </div>

            <p className="text-center">
              ¿No tiene una cuenta?{' '}
              <Link to="/registro" className="text-decoration-none">
                Registrese aqui
              </Link>
            </p>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
